import { render, staticRenderFns } from "./PedagioCadastro.vue?vue&type=template&id=d7285a12&scoped=true&"
import script from "./PedagioCadastro.vue?vue&type=script&lang=js&"
export * from "./PedagioCadastro.vue?vue&type=script&lang=js&"
import style0 from "./PedagioCadastro.vue?vue&type=style&index=0&id=d7285a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7285a12",
  null
  
)

export default component.exports